/**
 * Run-length horizontal segments per row for a binary mask (row-major).
 */

/**
 * @param {Uint8Array} mask
 * @param {number} width
 * @param {number} height
 * @param {number} [minRunWidthPx=1]
 * @returns {{ rowIndex: number, segments: { x0: number, x1: number }[] }[]}
 */
export function extractSlatSegments(mask, width, height, minRunWidthPx = 1) {
  const rows = [];

  for (let y = 0; y < height; y += 1) {
    const rowOffset = y * width;
    const segments = [];
    let runStart = null;

    for (let x = 0; x <= width; x += 1) {
      const on = x < width && mask[rowOffset + x] === 1;
      if (on && runStart === null) {
        runStart = x;
      }
      if ((!on || x === width) && runStart !== null) {
        const x0 = runStart;
        const x1 = x;
        if (x1 - x0 >= minRunWidthPx) {
          segments.push({ x0, x1 });
        }
        runStart = null;
      }
    }

    if (segments.length > 0) {
      rows.push({ rowIndex: y, segments });
    }
  }

  return rows;
}
